export const timeupdate = (date, hours, job) => {

  return {
      type: "TimeUpdate",
      payload : {
        date : date,
        hours : hours,
        job : job
      }
  }
};



// WEBPACK FOOTER //
// ./src/actions/timeupdate.js